"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var providePlaceholders_1 = require("../enhancers/providePlaceholders");
/**
 * Vue plugins must export a function named 'install'
 *
 * @param {typeof _Vue} Vue
 * @param {SitecoreJssPlaceholderPluginOptions} options
 */
function install(Vue, options) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$jss = __assign(__assign({}, Vue.prototype.$jss), { componentFactory: options && options.componentFactory });
    Vue.mixin({
        beforeCreate: function () {
            providePlaceholders_1.providePlaceholders(this, options && options.componentFactory);
        },
    });
}
exports.SitecoreJssPlaceholderPlugin = {
    install: install,
    key: 'SitecoreJssPlaceholderPlugin',
};
